module.exports = __webpack_public_path__ + "assets/android.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/devices/android.png
// module id = 990
// module chunks = 19